var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class Resize {
    // eslint-disable-next-line no-useless-constructor
    constructor(page, listener) {
        this.page = page;
        this.listener = listener;
        this.lastResize = null;
        this.isTracking = false;
        this.resizeupdatedhandler = (ev) => this.handleResizeEvent(ev);
    }
    track() {
        // send first window dimensions event
        this.handleResizeEvent(new Event("resize"));
        if (this.isTracking) {
            return;
        }
        this.page.getWindow().addEventListener("resize", this.resizeupdatedhandler);
        this.isTracking = true;
    }
    untrack() {
        var _a;
        if (!this.isTracking) {
            return;
        }
        (_a = this.page
            .getWindow()) === null || _a === void 0 ? void 0 : _a.removeEventListener("resize", this.resizeupdatedhandler);
        this.isTracking = false;
    }
    dispatch(event) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    handleResizeEvent(ev) {
        this.listener((this.lastResize = {
            width: this.page.getWindow().innerWidth,
            height: this.page.getWindow().innerHeight,
        }));
    }
}
//# sourceMappingURL=resize.js.map